'use client';

import { useEffect } from 'react';

/**
 * Registers /sw.js ONLY inside the native app shell (data-app-shell, set
 * pre-paint by AppShellInitScript) or an installed standalone PWA. The public
 * website never gets a service worker by side effect — a SW on the main
 * domains would add an un-clearable cache layer to a site that already fought
 * hard-to-debug immutable-cache issues in dev.
 */
export function SwRegister() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const inShell = document.documentElement.hasAttribute('data-app-shell');
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      // iOS Safari legacy signal
      (navigator as { standalone?: boolean }).standalone === true;

    if (!inShell && !standalone) return;

    navigator.serviceWorker
      .register('/sw.js')
      .then(async (registration) => {
        // Remote kill switch: if /sw-kill exists (deploy an empty file), tell
        // the worker to clear caches and unregister — no shell release needed.
        try {
          const res = await fetch('/sw-kill', { method: 'HEAD', cache: 'no-store' });
          if (res.ok) registration.active?.postMessage('iai-sw-kill');
        } catch {
          /* offline — fine */
        }
      })
      .catch((error) => {
        console.error('SW registration failed:', error);
      });
  }, []);

  return null;
}
